const blogProps = [
    {
        id: "1",
        name: "Consectetur adipisicing elit",
        img: "imgs/img-1.jpg",
        author: "Admin",
        likes: "123",
        comments: "234",
        content: "Lorem ipsum dolor sit ame, consectetur adipisicing elit. Impedit excepturi laborum eni, vitae ipsam atque eu, ad iusto consequuntur volupta, esse doloribus. Perferendis porro quisquam vitae exercitationem aliqui, minus eos laborum repudianda, cumque debitis iusto omnis praesentium? Laborum placeat sit adipisci illum tempore maxim, esse qui quae? Molestias excepturi corporis similique doloribus. Esse vitae earum architecto nulla non dolores illum at perspiciatis quo, et deleniti cupiditate reiciendis harum facer, delectus eum commodi soluta distinctio sit repudiandae possimus sunt. Ipsu, rem."
    },
    {
        id: "2",
        name: "Explicabo illo",
        img: "imgs/img-2.jpg",
        author: "Admin",
        likes: "456",
        comments: "789",
        content: "Lorem ipsum dolor sit ame, consectetur adipisicing elit. Impedit excepturi laborum eni, vitae ipsam atque eu, ad iusto consequuntur volupta, esse doloribus. Perferendis porro quisquam vitae exercitationem aliqui, minus eos laborum repudianda, cumque debitis iusto omnis praesentium? Laborum placeat sit adipisci illum tempore maxim, esse qui quae? Molestias excepturi corporis similique doloribus. Esse vitae earum architecto nulla non dolores illum at perspiciatis quo, et deleniti cupiditate reiciendis harum facer, delectus eum commodi soluta distinctio sit repudiandae possimus sunt. Ipsu, rem."
    },
]

export default blogProps;